import React, { Fragment } from 'react';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import { Helmet } from 'react-helmet';

import "./NotFoundPage.css";

const NotFoundPage = ({ path }) => {

    return (
        <>
            <Helmet>
                {/* Basic Meta Tags */}
                <title>JJFIndia | Page Not Found</title>
                <meta name="description" content="Page not found" />
                <meta name="keywords" content="" />
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <Fragment>
                <Header hclass={'header--styleFour'} />
                <main className="page_content">
                    <div style={{height:"80vh", width: "100%", background:"#EEE", marginTop: "60px"}}>
                        <div className="container-404">
                            <div className='text-404'>404</div>
                            <div className='page-text'>Page Not Found</div>

                            <div>
                                <div className="cc__button button-display" style={{ display: "block" }}>
                                    <div className="header__button" style={{ display: 'flex', flexDirection: 'column', rowGap: '18px' }}>
                                        <a className="btn btn--styleOne btn--primary it-btn" style={{ justifyContent: 'center' }} rel="noopener noreferrer" href='/' >
                                            <span className="btn__text">Back to Home</span>
                                            <i className="fa-solid fa-heart btn__icon"></i>
                                            <span className="it-btn__inner">
                                                <span className="it-btn__blobs">
                                                    <span className="it-btn__blob"></span>
                                                    <span className="it-btn__blob"></span>
                                                    <span className="it-btn__blob"></span>
                                                    <span className="it-btn__blob"></span>
                                                </span>
                                            </span>
                                            <svg className="it-btn__animation" xmlns="http://www.w3.org/2000/svg" version="1.1" >
                                                <defs>
                                                    <filter id="goo">
                                                        <feGaussianBlur in="SourceGraphic" result="blur" stdDeviation="10" ></feGaussianBlur>
                                                        <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 21 -7" result="goo"></feColorMatrix>
                                                        <feBlend in2="goo" in="SourceGraphic" result="mix" ></feBlend>
                                                    </filter>
                                                </defs>
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </main>
                <Footer />
                <Scrollbar />
            </Fragment>
        </>
    )
};

export default NotFoundPage;
